import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Eye, EyeOff } from 'lucide-react';
import { getSeverityColor, getSeverityLabel } from '@/data/personalityData';

const ScenarioInfo = ({ scenario, showScenario, onToggle }) => {
  return (
    <Card data-testid="scenario-info" className="glass border-0 mb-6">
      <CardHeader
        className="cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => onToggle(!showScenario)}
      >
        {showScenario ? (
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center justify-between mb-2">
                <CardTitle className="text-lg leading-tight">{scenario?.title}</CardTitle>
                <Badge
                  variant="outline"
                  className={`${getSeverityColor(scenario?.severity)} font-semibold text-xs`}
                  data-testid={`severity-${scenario?.id}`}
                >
                  {getSeverityLabel(scenario?.severity)}
                </Badge>
              </div>
              <CardDescription className="text-sm">{scenario?.location}</CardDescription>
            </div>
            <button
              className="ml-3 p-2 rounded-full hover:bg-gray-200 transition-colors"
              onClick={(e) => { e.stopPropagation(); onToggle(false); }}
              title="Masquer les détails"
            >
              <EyeOff className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <CardTitle className="text-lg leading-tight text-gray-400">Appel 911 en cours</CardTitle>
              <CardDescription className="text-sm text-gray-500">
                Cliquez pour voir les informations du scénario
              </CardDescription>
            </div>
            <button
              className="ml-3 p-2 rounded-full hover:bg-gray-200 transition-colors"
              onClick={(e) => { e.stopPropagation(); onToggle(true); }}
              title="Afficher les détails"
            >
              <Eye className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        )}
      </CardHeader>
      {showScenario && (
        <CardContent>
          <div className="space-y-3 text-sm">
            <div>
              <span className="font-semibold text-gray-700">Situation:</span>
              <p className="text-gray-600 mt-1">{scenario?.description}</p>
            </div>
            <div>
              <span className="font-semibold text-gray-700">Victime:</span>
              <p className="text-gray-600 mt-1">{scenario?.victim_info}</p>
            </div>
            <div>
              <span className="font-semibold text-gray-700">Instructions:</span>
              <p className="text-gray-600 mt-1">{scenario?.instructions}</p>
            </div>
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default ScenarioInfo;
